export default __webpack_public_path__ + "static/media/logo-black.c18207a6.svg";